import type { ChildScores } from '@yandex-int/k-common';
import * as api from '@yandex-int/k-common/client/api';
import { showNetworkError } from 'platform-components';
import { all, call, put, takeEvery } from 'redux-saga/effects';

import * as actions from './actions';
import { GET_LESSON_CERTIFICATES_REQUEST, GET_LESSON_SCORES_REQUEST } from './constants';
import { GET_CHILDREN_SCORE_ERROR_MESSAGE } from './typings';

export function* certificatesWatcher() {
    yield all([
        takeEvery(GET_LESSON_CERTIFICATES_REQUEST, getLessonCertificatesRequestSaga),
        takeEvery(GET_LESSON_SCORES_REQUEST, getLessonScoresRequestSaga),
    ]);
}

// используем эту переменную, чтобы избавиться от дублирующихся запросов из-за того, что
// class-results-chart рендерится дважды (в обложке и тамбнейлах)

let areCertificatesLoading = false;

function* getLessonCertificatesRequestSaga(action: ReturnType<typeof actions.getLessonCertificatesRequest>) {
    const { clessonId } = action;

    try {
        if (!areCertificatesLoading) {
            const certificates: Record<number, string> = yield call(api.getClessonCertificates, clessonId);

            yield put(actions.getLessonCertificatesSuccess(clessonId, certificates));

            areCertificatesLoading = false;
        }
    } catch (error) {
        console.error(error);

        yield put(actions.getLessonCertificatesError(clessonId));
        yield put(showNetworkError(error));
    }
}

export function* getLessonScoresRequestSaga(action: ReturnType<typeof actions.getLessonScoresRequest>) {
    const { clessonId, childIds } = action;

    try {
        const scores: ChildScores = yield call(api.getChildrenScores, clessonId, childIds);

        yield put(actions.setLessonScores(clessonId, scores));
    } catch (error) {
        if (Object.values(GET_CHILDREN_SCORE_ERROR_MESSAGE).includes(error.data?.errors?.[0]?.message)) {
            return;
        }

        console.error(error);

        yield put(showNetworkError(error));
    }
}
